import { type MultidietResponseType } from '../types/multidiet.type';
import { DietSearchResultsItemType } from '@/features/diets/types/diet-search-resilts.type';
import { create } from 'zustand';

type Store = {
  multidiet: MultidietResponseType | null;
  diets: { day: string; diet: DietSearchResultsItemType }[];
  reloading: boolean;
  deliveryDate: Date[] | null;
  isCustomDeliveryDate: boolean;
};

type Actions = {
  setMultidiet: (multidiet: MultidietResponseType | null) => void;
  setMultidietDiets: ({
    day,
    diet,
  }: {
    day: string;
    diet: DietSearchResultsItemType;
  }) => void;
  setReloading: (reloading: boolean) => void;
  setDeliveryDate: (deliveryDate: Date[] | null) => void;
  setIsCustomDeliveryDate: (isCustomDeliveryDate: boolean) => void;
};

const initialState: Store = {
  multidiet: null,
  diets: [],
  reloading: false,
  deliveryDate: null,
  isCustomDeliveryDate: false,
};

const useMultidietStore = create<Store & Actions>()((set) => ({
  ...initialState,
  setMultidiet: (multidiet) => set({ multidiet, diets: [] }),
  setMultidietDiets: ({ day, diet }) =>
    set((state) => ({
      diets: state.diets.some((item) => item.day === day)
        ? state.diets.map((item) =>
            item.day === day ? { ...item, diet } : item,
          )
        : [...state.diets, { day, diet }],
    })),
  setReloading: (reloading) => set({ reloading }),
  setDeliveryDate: (deliveryDate) => set({ deliveryDate }),
  setIsCustomDeliveryDate: (isCustomDeliveryDate) =>
    set({ isCustomDeliveryDate }),
}));

export default useMultidietStore;
